import AccessorialRequestWebAPIUtils from '../utils/AccessorialRequestWebAPIUtils';

export default {
  approveAccessorials(body) {
    AccessorialRequestWebAPIUtils.approveAccessorials(body);
  },
  declineAccessorials(body) {
    AccessorialRequestWebAPIUtils.declineAccessorials(body);
  },
  acceptAccessorials(body) {
    AccessorialRequestWebAPIUtils.acceptAccessorials(body);
  },
  createAccessorialRequest(exception) {
    AccessorialRequestWebAPIUtils.createAccessorialRequest(exception);
  },
  getAccessorialRequests(query, options) {
    AccessorialRequestWebAPIUtils.getAccessorialRequests(query, options);
  },
  updateAccessorialException(exception) {
    return AccessorialRequestWebAPIUtils.updateAccessorialException(exception);
  },
  updateAccessorialRequest(updates) {
    AccessorialRequestWebAPIUtils.updateAccessorialRequest(updates);
  },
  bulkCreateAccessorialRequests(requests) {
    AccessorialRequestWebAPIUtils.createBulkAccessorialRequests(requests);
  },
};
